var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-container"},[_c('iframe',{attrs:{"src":"/pdf-service","width":"100%","height":"800px","frameborder":"0","allowfullscreen":""}})])
}]

export { render, staticRenderFns }